export const createQueryString = <T extends Object>(obj: T | null) => {
  if (!obj) return ''
  const queryString = Object.entries(obj)
    .filter(([key, value]) => !!key && !!value)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&')

  return `?${queryString}`
}

//обновленная функция для параметров; корректно обрабатывает, если массив, например несколько id передается
export const createQueryStringSmart = <T extends Record<string, any>>(
  obj: T | null,
  commaKeys: string[] = ['ordering', 'dimension_types', 'compliant_type'],
): string => {
  if (!obj) return ''

  const searchParams = new URLSearchParams()

  Object.entries(obj).forEach(([key, value]) => {
    if (
      value === null ||
      value === undefined ||
      value === '' ||
      (typeof value === 'number' && isNaN(value))
    ) {
      return
    }

    if (Array.isArray(value)) {
      value
        .filter((v) => v !== null && v !== undefined && v !== '')
        .forEach((v) => {
          searchParams.append(key, String(v))
        })
    } else if (
      typeof value === 'string' &&
      commaKeys.includes(key) &&
      value.includes(',')
    ) {
      value
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s.length > 0)
        .forEach((part) => searchParams.append(key, part))
    } else {
      searchParams.append(key, String(value))
    }
  })

  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}
